<div class="mt-4">

  <div class="row p-1 div-cenered mt-15">
    <h2>Встреча #3</h2>
    <p class="fs12">19.03.2022, 11:30 </p>
  </div>

  <div class="row justify-content-center mt--15">

    <div class="col-2 ">
      <div class="d-flex div-cenered">
        <div class="">
          <img src="static/img/avatar/1.jpg" alt="name">
          <p class="fs16 fc-main mt-2 ">Иванов Петр Сергеевич</p>
          <p class="fs12 mt--15 ">1986, КМС<br>Россия<br> Нижний Новгород</p>
        </div>
      </div>
    </div>


    <div class="col-3 ">
      <table class="table table-hover ">

        <tbody>
          <tr>
            <td>
              <div class="cell">?</div>
            </td>
            <td>
              <div class="cell">3</div>
            </td>
            <td>
              <div style="min-width:100px" class="cell">Имя Фамилия</div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered-prim_color">3</div>
              </div>
            </td>

            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered">2</div>
              </div>
            </td>
            <td>
              <div style="min-width:100px" class="cell">Имя Фамилия</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="cell">?</div>
            </td>
            <td>
              <div class="cell">3</div>
            </td>
            <td>
              <div class="cell">Имя Фамилия</div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered">2</div>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered-prim_color">3</div>
              </div>
            </td>
            <td>
              <div class="cell">Имя Фамилия</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="cell">?</div>
            </td>
            <td>
              <div class="cell">3</div>
            </td>
            <td>
              <div class="cell">Имя Фамилия</div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered-prim_color">5</div>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div class="cell-bordered">2</div>
              </div>
            </td>
            <td>
              <div class="cell">Имя Фамилия</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>